import Swal from 'sweetalert2';
export const submitExpense = async (formData) => {
  try {
    Swal.fire({
      title: 'En cours...',
      text: 'Ajout de la dépense en cours, veuillez patienter.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const response = await fetch('/api/add-expense', {
      method: 'POST',
      body: formData,
      credentials: 'include'
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Erreur lors de l\'ajout de la dépense');
    }

    const data = await response.json();

    await Swal.fire({
      icon: 'success',
      title: 'Succès !',
      text: 'La dépense a été ajoutée avec succès.',
      confirmButtonText: 'OK'
    });

    return { success: true, data };
  } catch (error) {
    console.error('Erreur:', error);
    await Swal.fire({
      icon: 'error',
      title: 'Erreur',
      text: error.message || 'Une erreur est survenue lors de l\'ajout de la dépense.',
      confirmButtonText: 'OK'
    });
    return { success: false, error };
  }
}; 